export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    title: that.$l('table_label_displayImage') || '图片',
    field: 'displayImage',
    width: 70,
    align: 'center',
    fixed: 'left',
    slots: { default: 'displayImage' },
  },
  {
    title: that.$l('table_label_displaySkuName') || 'SKU名称',
    field: 'displaySkuName',
    minWidth: 280,
    fixed: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displaySkuName' },
  },
  {
    title: that.$l('table_label_displaySalesTitle') || '售卖标题',
    field: 'displaySalesTitle',
    minWidth: 280,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displaySalesTitle' },
  },
  {
    title: that.$l('table_label_displayPlatform') || '渠道',
    field: 'displayPlatform',
    minWidth: 200,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayPlatform' },
  },
  {
    title: that.$l('table_label_displayWarehouse') || '仓库',
    field: 'displayWarehouse',
    minWidth: 200,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayWarehouse' },
  },
  {
    title: that.$l('table_label_displayProductUnit') || '产品单位入数',
    field: 'displayProductUnit',
    minWidth: 120,
    align: 'left',
    slots: { default: 'displayProductUnit' },
  },
  {
    title: that.$l('table_label_salesPrice') || '售卖价格',
    field: 'salesPrice',
    minWidth: 140,
    align: 'left',
    showHeaderOverflow: true,
    formatter: ({ row }) => {
      const { salesPrice, v_salesCurrencyUnit } = row
      return [that.format(salesPrice), v_salesCurrencyUnit]
        .filter(Boolean)
        .join(' ')
    },
  },
  {
    title: that.$l('table_label_operateName') || '运营人员',
    field: 'operateName',
    minWidth: 160,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayFactory') || '工厂',
    field: 'displayFactory',
    minWidth: 200,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayFactory' },
  },
]
